import { render, staticRenderFns } from "./SettingQuestions.vue?vue&type=template&id=5e2d6e06&scoped=true&"
import script from "./SettingQuestions.vue?vue&type=script&lang=js&"
export * from "./SettingQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d6e06",
  null
  
)

export default component.exports